<template>
  <div>
    <div class="editor xs12">
        <div class="menubar" v-if="editor">

          <button :class="{ 'is-active': editor.isActive('bold') }" @click="editor.chain().toggleBold().focus().run()">
            Bold
          </button>
          
          <button :class="{ 'is-active': editor.isActive('italic') }" @click="editor.chain().toggleItalic().focus().run()">
            Italic
          </button>
          
          <!-- <button :class="{ 'is-active': editor.isActive.heading({ level: 1 }) }" @click="editor.chain().toggleHeading({ level: 1 })().focus().run()">
            H1
          </button>
          <button :class="{ 'is-active': editor.isActive.heading({ level: 2 }) }" @click="editor.chain().toggleHeading({ level: 2 })().focus().run()">
            H2
          </button>
          <button :class="{ 'is-active': editor.isActive.heading({ level: 3 }) }" @click="editor.chain().toggleHeading({ level: 3 })().focus().run()">
            H3
          </button> -->
          
          <button class="menubar__button" :class="{ 'is-active': editor.isActive('underline') }" @click="editor.chain().toggleUnderline().focus().run()" >
            U
          </button>
          
          <button class="menubar__button" :class="{ 'is-active': editor.isActive('code') }" @click="editor.chain().toggleCode().focus().run()" >
            C
          </button>
          
          <button class="menubar__button" :class="{ 'is-active': editor.isActive('bullet_list') }" @click="editor.chain().toggleBullet_list().focus().run()" >
            UL
          </button>

          <button class="menubar__button" :class="{ 'is-active': editor.isActive('ordered_list') }" @click="editor.chain().toggleOrdered_list().focus().run()" >
            OL
          </button>

          <!-- <button class="menubar__button" :class="{ 'is-active': editor.isActive('blockquote') }" @click="editor.chain().toggleblockquote().focus().run()" >
            Q
          </button> -->
          <!-- <button class="menubar__button" :class="{ 'is-active': editor.isActive('code_block') }" @click="editor.chain().togglecode_block().focus().run()" >
            CODE
          </button> -->
          <!-- <button class="menubar__button" @click="editor.chain().togglehorizontal_rule().focus().run()" >
            HR
          </button>
          <button class="menubar__button" @click="editor.chain().toggleundo().focus().run()" >
            <icon name="undo" />
          </button>
          <button class="menubar__button" @click="editor.chain().toggleredo().focus().run()" >
            <icon name="redo" />
          </button> -->

        </div>
      <editor-content class="xs12 pa-0 editor__content" :editor="editor" />
    </div>
    <v-flex text-xs-right>
      <v-btn @click="copy2c" small icon>
        <v-icon small>file_copy</v-icon>
      </v-btn>
      <v-btn @click="download_text" small icon>
        <v-icon small>download</v-icon>
      </v-btn>
    </v-flex>
  </div>
</template>

<script>
  import { Editor, EditorContent } from '@tiptap/vue-2'
  // import { defaultExtensions } from '@tiptap/starter-kit'
  import StarterKit from '@tiptap/starter-kit'

  export default {

    methods: {
      
      copy2c() {
        const t = this.value
        const listener = function(ev) {
          // console.log(ev)
          ev.preventDefault();
          ev.clipboardData.setData('text/html', t);
          ev.clipboardData.setData('text/plain', t);
        };
        document.addEventListener('copy', listener);
        document.execCommand('copy');
        document.removeEventListener('copy', listener);
      },
      
      download_text() {
        var text_title = ''
        if (this.text) {
          text_title = this.text.title
        }
        this.exportHTML(this.value, text_title);
      },

    },
    
    components: { EditorContent },

    props: [ 'value', 'text', 'artwork' ],

    data() {
      return {
        editor: null,
        // editor: new Editor({
        //   extensions: [
        //     new Heading({ levels: [1, 2, 3] }),
        //     new BulletList(),
        //     new OrderedList(),
        //     new ListItem(),
        //     new Bold(),
        //     new Code(),
        //     new Italic(),
        //     new Link(),
        //     new Underline(),
        //     new History()
        //   ],
        //   content: this.value,
        //   onUpdate: ( { editor.state, getHTML, getJSON, transaction } ) => {
        //     // console.log(getHTML())
        //     this.$emit('input', getHTML())
        //   }              
        // }),
      }
    },
    
    mounted() {
      console.log(this.value)
      this.editor = new Editor({
          extensions: [
            StarterKit,
            // ...defaultExtensions(),
          ],
          content: this.value,
          onUpdate: ({ editor }) => {
            // console.log(editor.getHTML())
            this.$emit('input', editor.getHTML())
          }              
        })
    },
    watch: {
      value(value) {
        // HTML
        const isSame = this.editor.getHTML() === value

        // JSON
        // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

        if (isSame) {
          return
        }

        this.editor.commands.setContent(value, false)
      }
            // value (val) {
        //     // so cursor doesn't jump to start on typing
        //     if (val !== this.editor.getHTML()) {
        //     this.editor.setContent(val)
        //     }
        // }
    },
    beforeDestroy() {
      this.editor.destroy()
    },    
  }

  // console.log(state, transaction)
  // console.log(getHTML(), getJSON())
  //         new Strike(),
  // new TodoItem(),
  // new TodoList(),
  // new Blockquote(),
  // new CodeBlock(),
  // new HardBreak(),

  // mounted() {
  //   this.editor = new Editor({
  //     extensions: [],
  //     onUpdate: ({ getHTML }) => {
  //       this.$emit('input', getHTML())
  //     },

  //   })
  //   this.editor.setContent(this.value)
  // },
  // components: { Editor, EditorContent, EditorMenuBar}
  // import Document from '@tiptap/extension-document'
  // import Paragraph from '@tiptap/extension-paragraph'
  // import Text from '@tiptap/extension-text'
  // CodeBlock,
  // HorizontalRule,
  // import {
  //   Code,
  //   // Blockquote,
  //   // HardBreak,
  //   Heading,
  //   OrderedList,
  //   BulletList,
  //   ListItem,
  //   // T odoItem,
  //   // T odoList,
  //   Bold,
  //   Italic,
  //   Link,
  //   // Strike,
  //   Underline,
  //   History
  // } from 'tiptap-extensions'

</script>

<style >
  .editor {
    width:100%;
    margin: 0px;
  }
  .editor button {
    padding: 5px 10px;
    border:1px solid black;
    margin-bottom: 10px;
  }
  .editor button.is-active {
    background-color: black;
    color: white;
  }
  .editor .editor__content {
    padding: 10px;
    border: 1px solid black;
    border-top: 1px solid black;
    margin: 0px;
  }
  *:focus, textarea:focus, select:focus{
    outline: none;
  }
  .editor textarea, select, input, button { outline: none; display: inline-block;}
  .ProseMirror { display: inline-block; min-height: 200px; width:100%;}
  /* .editor p { margin: 0px !important; padding: 0px !important; background-color: white;} */
  .ProseMirror p { margin-bottom: 0px !important; padding-left: 10px !important;}
  .editor__content { display: inline-block; min-height: 200px; width:100%;}
  .editor .editor__content { line-height: 1.5; padding: 10px !important; margin-bottom: 0px !important; font-size: 18px; }
  .editor p { margin-bottom: 0px !important; line-height: 1.3; }
</style>



// WEBPACK FOOTER //
// src/components/artworks/TextEditor.vue